<script>
    import {Line, mixins} from 'vue-chartjs'
    import ChartJsPluginDataLabels from 'chartjs-plugin-labels';

    const {reactiveProp} = mixins

    export default {
        extends: Line,
        mixins: [reactiveProp],
        components: {
            ChartJsPluginDataLabels
        },
        props: {
            chartData: {
                type: Object,
                default: null
            }
        },
        mounted() {
            this.renderChart(this.chartData, {
                maintainAspectRatio: false,
                responsive: true,
                legend: {
                    display: true
                },
                tooltips:{
                    mode:'index',
                    intersect: false
                },
                // title: {
                //     display: false,
                //     text: ''
                // },
                plugins: {
                    labels: {
                        render: 'value',
                        fontColor: 'white'
                    }
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    yAxes: [{
                        // barPercentage: 1.5,
                        // barThickness: 50,
                        // maxBarThickness: 50,
                        minBarLength: 1,
                        gridLines: {
                            offsetGridLines: true
                        }
                    }]
                }
            })
        }
    }
</script>

